import { BaseRepository } from "approot/global/repository/baseRepository";
import { PasswordRecoveryComponent } from "../password.recovery.component";

export enum PswRecoveryType {
	Email = "Email",
	MobPhone = "MobPhone"
}

export interface PasswordRecoveryRequest {
	// Способ восстановления
	recoveryType: PswRecoveryType;
	// Значение соответствующее способу восстановления
	recoveryValue: string;
	//
	checkedAnswer?: boolean;
}

export interface PasswordRecoveryResponse {
	// Идентификатор пользователя
	userId: number;
	// Контрольный вопрос
	question: string;
}

export interface RecoveryAnswerVerificationRequest {
	// Ответ
	answer: string;
	// Способ восстановления
	recoveryType:PswRecoveryType;
	// Значение соответствующее способу восстановления
	recoveryValue: string;
}

export interface RecoveryAnswerVerificationResponse {
	message: string;
}

export class PasswordRecoveryRepository extends BaseRepository {
	validate(passwordRecoveryRequest: PasswordRecoveryRequest): Promise<PswRecoveryType> {
		return this.$http.post("/webapi/password/recovery-validate", passwordRecoveryRequest)
			.then(this.handleResponse, this.handleError);
	}

	getRecoveryResponse(passwordRecoveryRequest: PasswordRecoveryRequest): Promise<PasswordRecoveryResponse> {
		return this.$http.get("/webapi/password/recovery-response", { params: passwordRecoveryRequest })
			.then(this.handleResponse, this.handleError);
	}

	getRecoveryVerificationResponse(recoveryAnswerVerificationRequest: RecoveryAnswerVerificationRequest): Promise<RecoveryAnswerVerificationResponse> {
		return this.$http.post("/webapi/password/recovery-answer-verification", recoveryAnswerVerificationRequest)
			.then(this.handleResponse, this.handleError);
	}
}

export class PasswordRecoveryService {
	/*@ngInject*/
	constructor(
		private $location: ng.ILocationService
	) {
	}

	goToPassRecovery() {
		this.$location.path("/authorize/passrecovery");
	}
}